import { render } from "./NcFooter.vue?vue&type=template&id=1c398444&scoped=true"
import script from "./NcFooter.vue?vue&type=script&lang=js"
export * from "./NcFooter.vue?vue&type=script&lang=js"

import "./NcFooter.vue?vue&type=style&index=0&id=1c398444&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c398444"]])

export default __exports__